import React from "react"
import ReactDOM from "react-dom"
import "./index.css"
import App from "./components/App"
import registerServiceWorker from "./registerServiceWorker"
import ErrorBoundary from "./components/ErrorBoundary"

ReactDOM.render(
    <ErrorBoundary>
        <App />
    </ErrorBoundary>
    , document.getElementById("root"))
registerServiceWorker()

if(module.hot) {
    module.hot.accept() 
}


// WEBPACK FOOTER //
// ./src/index.js